import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectContext = /*#__PURE__*/createContext(undefined);
export const SelectProvider = ({
  buttonStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    buttonStyleOverrides
  }), [buttonStyleOverrides]);
  return /*#__PURE__*/_jsx(SelectContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `Select` component.
 * Note: The context is only available when the `Select` component is rendered as an ancestor.
 * @returns SelectContext - The context for the `Select` component.
 * @returns SelectContext.buttonStyleOverrides - CSS overrides to apply to the `Button` component.
 */
export const useSelectContext = () => {
  const selectContext = useContext(SelectContext);
  return selectContext;
};